module.exports = __webpack_public_path__ + "img/84.bda76752.jpg";